module.exports = __webpack_public_path__ + "static/scale-model-of-the-farm-at-gardner-village-in-west-jordan-utah-b54f3aa1f186997698973550cb07c735.png";